export type ChoosePlanSubscriptionAction =
    | "create"
    | "recover_incomplete"
    | "restart"
    | "recover_payment"
    | "resume_paused"
    | "existing";

export function classifyChoosePlanSubscription(
    status: string | null | undefined,
    hasSubscriptionSnapshot: boolean
): ChoosePlanSubscriptionAction {
    switch (status?.trim().toLowerCase()) {
        case "incomplete":
            return "recover_incomplete";
        case "incomplete_expired":
            return "create";
        case "canceled":
            return "restart";
        case "past_due":
        case "unpaid":
            return "recover_payment";
        case "paused":
            return "resume_paused";
        case "":
        case "none":
        case undefined:
            return hasSubscriptionSnapshot ? "existing" : "create";
        default:
            return "existing";
    }
}
